import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useContext } from "react";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { Col, FormGroup, Input, NavLink, Row, TabContent /*, TabPane*/, } from "reactstrap";
import axios from "../../api/axios";
import { toast } from "react-toastify";
// import { useLocation, useNavigate } from 'react-router-dom';
// import AuthContext from "../../context/AuthProvider";
import Button from "../global/Button";
import SubHeader from "./SubHeader";
import TopHeader from "./TopHeader";
import { BsChevronRight } from "react-icons/bs";
import { GlobalContext } from "../../App";
import { useNavigate, useLocation } from "react-router-dom";
function ChangePassword(props) {
  const navigate = useNavigate();

  // const [activeTab, setActiveTab] = useState('1');
  const [oldpasswordStatus, setOldPasswordStatus] = useState("password");
  const [newpasswordStatus, setNewPasswordStatus] = useState("password");
  const [confirmpasswordStatus, setConfirmPasswordStatus] =
    useState("password");
  const [oldPassword, setOldPassword] = useState(""); // Initialize with an empty string
  const [pwd, setPwd] = useState("");
  const [matchPwd, setMatchPwd] = useState("");
  const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
  // const [pwdFocus, setPwdFocus] = useState(false);
  // const [matchFocus, setMatchFocus] = useState(false);
  const [validPwd, setValidPwd] = useState(false);
  const [validMatch, setValidMatch] = useState(false);
  // const navigate = useNavigate();
  // const location = useLocation();
  // const { setAuth } = useContext(AuthContext);
  const { rolexModuleData, roles } = useContext(GlobalContext);
  const location = useLocation();
  const { pathname } = location;

  const postChangePassword = (e) => {
    e.preventDefault();
    if (oldPassword === null || oldPassword === "") {
      toast.error("Old password is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (pwd === null || pwd === "") {
      toast.error("Please enter new password!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (!validPwd) {
      toast.error(
        "Password must be of 8 to 24 characters - 1 uppercase, 1 lowercase, 1 number and a special character!",
        {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000,
        }
      );
    } else if (matchPwd === null || matchPwd === "") {
      toast.error("Please enter confirm password!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (validMatch === false) {
      toast.error(" Password does not matched!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (oldPassword === pwd) {
      toast.error("New password cannot be set same as old password!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else {
      const params = {
        user_id:localStorage.getItem('user_id')&&atob(localStorage.getItem('user_id')) || '',
        old_password: oldPassword,
        new_password: pwd,
      };
      axios
        .post("/updatePassword", params)
        .then((response) => {
          if (response?.status === 202) {
            toast.error("Old password is incorrect!", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            });
          } else {
            toast.success("Password is changed successfully!", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            });
            setOldPassword("");
            setPwd("");
            setMatchPwd("");
            setOldPasswordStatus("password");
            setNewPasswordStatus("password");
            setConfirmPasswordStatus("password");
            setValidPwd(false);
          }
        })
        .catch((error) => {
          const statusCode = error.response ? error.response.status : null;
          // Handle the error here based on the status code received
          if (statusCode === 500) {
            toast.error("postChangePassword : Internal Server Error !", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            });
            // Handle 500 Internal Server Error
          } else if (statusCode === 404) {
            toast.error("Page Not Found !", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            });
            // Handle 404 Not Found
          } else {
            toast.error("No postChangePassword API Response !", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            });
            // Handle other error scenarios
          }
        });
    }
  };

  useEffect(() => {
    setValidPwd(PWD_REGEX.test(pwd));
    setValidMatch(pwd === matchPwd);
  }, [pwd, matchPwd]);

  return (
    <>
      <TopHeader
        breadCrumb={
          <>
            <li className="nav-item">
              <a onClick={() => navigate("/home")} className="nav-link">
                Home <BsChevronRight />
              </a>
            </li>
            <li className="nav-item">
              <span>Change Password</span>
            </li>
          </>
        }
      />
      <SubHeader SubHeaderTitle="Change Password" />
      <div className="manage-table changePassword contentInnerWrap">
        <Row>
          <Col md={12}>
            <TabContent>
              {/* activeTab="1" */}
              {/* <TabPane tabId="1"> */}
              <Row>
                <Col sm="12">
                  <div className="form">
                    {/* <div className='heading'>
                                                <h2>Change Password </h2>
                                            </div> */}
                    <form
                      className="personal-info-details prinfo"
                      onSubmit={postChangePassword}
                    >
                      <Row>
                        <Col md={12}>
                          <label htmlFor="password" className="form-label">
                            Old Password:{" "}
                          </label>
                          <div className="input-icon">
                            {oldpasswordStatus === "password" ? (
                              <NavLink
                                className="icon"
                                onClick={() => setOldPasswordStatus("text")}
                              >
                                <BsEyeSlash />
                              </NavLink>
                            ) : (
                              <NavLink
                                className="icon"
                                onClick={() => setOldPasswordStatus("password")}
                              >
                                <BsEye />
                              </NavLink>
                            )}
                            <Input
                              id="password"
                              name="password"
                              className="myInput"
                              type={oldpasswordStatus}
                              placeholder="Enter Old Password"
                              value={oldPassword}
                              onChange={(e) => setOldPassword(e.target.value)}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <label htmlFor="password" className="form-label">
                            New Password:
                            <FontAwesomeIcon
                              icon={faCheck}
                              className={validPwd ? "valid" : "hide"}
                            />
                            <FontAwesomeIcon
                              icon={faTimes}
                              className={validPwd || !pwd ? "hide" : "invalid"}
                            />
                          </label>
                          <div className="input-icon">
                            {newpasswordStatus === "password" ? (
                              <NavLink
                                className="icon"
                                onClick={() => setNewPasswordStatus("text")}
                              >
                                <BsEyeSlash />
                              </NavLink>
                            ) : (
                              <NavLink
                                className="icon"
                                onClick={() => setNewPasswordStatus("password")}
                              >
                                <BsEye />
                              </NavLink>
                            )}
                            <Input
                              className="myInput"
                              type={newpasswordStatus}
                              id="newpassword"
                              name="newpassword"
                              onChange={(e) => setPwd(e.target.value)}
                              value={pwd}
                              aria-invalid={validPwd ? "false" : "true"}
                              aria-describedby="pwdnote"
                              // onFocus={() => setPwdFocus(true)}
                              // onBlur={() => setPwdFocus(false)}
                              placeholder=" New Password"
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <label htmlFor="confirm_pwd" className="form-label">
                            Confirm Password:
                            <FontAwesomeIcon
                              icon={faCheck}
                              className={
                                validMatch && matchPwd ? "valid" : "hide"
                              }
                            />
                            <FontAwesomeIcon
                              icon={faTimes}
                              className={
                                validMatch || !matchPwd ? "hide" : "invalid"
                              }
                            />
                          </label>
                          <div className="input-icon">
                            {confirmpasswordStatus === "password" ? (
                              <NavLink
                                className="icon"
                                onClick={() => setConfirmPasswordStatus("text")}
                              >
                                <BsEyeSlash />
                              </NavLink>
                            ) : (
                              <NavLink
                                className="icon"
                                onClick={() =>
                                  setConfirmPasswordStatus("password")
                                }
                              >
                                <BsEye />
                              </NavLink>
                            )}
                            <Input
                              type={confirmpasswordStatus}
                              id="confirm_pwd"
                              name="confirm_pwd"
                              onChange={(e) => setMatchPwd(e.target.value)}
                              value={matchPwd}
                              aria-invalid={validMatch ? "false" : "true"}
                              aria-describedby="confirmnote"
                              // onFocus={() => setMatchFocus(true)}
                              // onBlur={() => setMatchFocus(false)}
                              placeholder="Confirm Password"
                            />
                          </div>
                        </Col>
                      </Row>

                      {rolexModuleData?.find(
                        (data) =>
                          pathname === data?.description && data?.update === 1
                      ) ||
                      roles?.find((data) => data?.role_id === 1001) ? (
                        <Row>
                          <Col md={12}>
                            <FormGroup>
                              <Col md={12}>
                                <label>&nbsp;</label>
                                <Button
                                  color="primary"
                                  className="btn"
                                  type="submit"
                                  style={{
                                    marginLeft: "0",
                                    boxShadow: "none",
                                    padding: "0",
                                  }}
                                >
                                  Update Password
                                </Button>{" "}
                              </Col>
                            </FormGroup>
                          </Col>
                        </Row>
                      ) : null}
                    </form>
                  </div>
                </Col>
              </Row>
              {/* </TabPane> */}
            </TabContent>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default ChangePassword;
